<nz-spin [nzSpinning]="isLoading">
  <div class="grid_parent" #infoContainer>
    <div>
      <nz-input-group class="legacy-input-styling">
        <label>Shot X offset</label>
        <nz-input-number style="width: 100%" [(ngModel)]="xOffset" (nzBlur)="onBoundsChanged()"
        (keyup.enter)="onBoundsChanged()"></nz-input-number>
      </nz-input-group>
    </div>
    <div>
      <nz-input-group class="legacy-input-styling">
        <label>Shot Y offset</label>
        <nz-input-number style="width: 100%" [(ngModel)]="yOffset" (nzBlur)="onBoundsChanged()"
        (keyup.enter)="onBoundsChanged()"></nz-input-number>
      </nz-input-group>
    </div>
    <div>
      <nz-input-group class="legacy-input-styling">
        <label>Width</label>
        <nz-input-number [nzMin]="0" style="width: 100%" [(ngModel)]="boxWidth" (nzBlur)="onBoundsChanged()"
        (keyup.enter)="onBoundsChanged()"></nz-input-number>
      </nz-input-group>
    </div>
    <div>
      <nz-input-group class="legacy-input-styling">
        <label>Height</label>
        <nz-input-number [nzMin]="0" style="width: 100%" [(ngModel)]="boxHeight" (nzBlur)="onBoundsChanged()"
        (keyup.enter)="onBoundsChanged()"></nz-input-number>
      </nz-input-group>
    </div>

    <div>
      <nz-input-group class="legacy-input-styling"><label>Receiver Interval</label>
      <nz-input-number style="width: 100%" [(ngModel)]="rcvrInterval" [nzMin]="1">
      </nz-input-number>
    </nz-input-group>
  </div>
  <div>
    <nz-input-group class="legacy-input-styling">
      <label>Receiver Sorting Index</label>
      <nz-select style="width: 100%" [(ngModel)]="sortingIndex">
        <nz-option nzValue="id" nzLabel="Receiver ID"></nz-option>
        <nz-option nzValue="distance" nzLabel="Receiver Distance"></nz-option>
        <nz-option nzValue="crossline" nzLabel="Receiver Crossline"></nz-option>
        <nz-option nzValue="inline" nzLabel="Receiver Inline"></nz-option>
      </nz-select>
    </nz-input-group>
  </div>
  <div>
    <nz-input-group class="legacy-input-styling">
      <label>Receiver Sorting Direction</label>
      <nz-select style="width: 100%" [(ngModel)]="sortingDirection">
        <nz-option nzValue="desc" nzLabel="Descending"></nz-option>
        <nz-option nzValue="asc" nzLabel="Ascending"></nz-option>
      </nz-select>
    </nz-input-group>
  </div>

  @if (this.panel == 'Interleaved') {
    <div>
      <nz-input-group class="legacy-input-styling">
        <label>Interleave Extent</label>
        <nz-input-number style="width: 100%" [(ngModel)]="interleave_extent" [nzMin]="1"></nz-input-number>
      </nz-input-group>
    </div>
  }
  <div>
    <nz-input-group class="legacy-input-styling">
      <label>Scaling</label>
      <nz-input-number style="width: 100%" [(ngModel)]="scaling" [nzMin]="0" (nzBlur)="onScalingCommitted()"
        (keyup.enter)="onScalingCommitted()"></nz-input-number>
    </nz-input-group>
  </div>
  <div>
    <nz-input-group class="legacy-input-styling">
      <label>Data Type</label>
      <nz-select style="width: 100%" [(ngModel)]="shotDisplayType" (ngModelChange)="shotDisplayTypeChanged($event)">
        <nz-option nzValue="lowpass-B4" nzLabel="Raw"></nz-option>
        <nz-option nzValue="compare" nzLabel="Compare"></nz-option>
      </nz-select>
    </nz-input-group>
  </div>

  <div style="display: flex; justify-content: center; align-items: center">
    <div style="display: flex; width: 100%">
      <button nz-button (click)="updateShotGraph()" nzType="primary" style="flex-grow: 1l; width: 100%">
        Plot Graph
      </button>
      <button nz-button (click)="updateShotGraph(true)" style="width: 50px" nz-tooltip nzTooltipTitle="Force replot">
        <span nz-icon nzType="retweet" nzTheme="outline"></span>
      </button>
    </div>
  </div>
  <div style="display: flex; justify-content: space-between; align-items: center; grid-column: span 2 / span 2;">
    <span>
      Number of selected receivers:
      <br />
      {{ this.rcvrsInBoundingBox?.length }}
    </span>
    <button nz-button nzType="primary" (click)="showReceiversModal()" [disabled]="!rcvrsInBoundingBox?.length">
      Show
    </button>
  </div>

</div>

<div #graphContainer>
  <svg #graph></svg>
</div>
</nz-spin>
<nz-modal [(nzVisible)]="showReceiversModalVisible" nzTitle="Selected Receivers" (nzOnCancel)="closeReceiversModal()"
  [nzWidth]="500" [nzFooter]="modalFooter">
  <ng-container *nzModalContent>
    <div style="max-height: 400px; overflow-y: auto;">
      <nz-list nzBordered nzSize="small">
        @for (group of rangeGroups; track group) {
          <nz-list-item>
            <label nz-checkbox [(ngModel)]="group.selected" style="width: 100%;">
              {{ group.label }}
            </label>
          </nz-list-item>
        }
      </nz-list>
    </div>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="copyAllIndices()">
      Copy All
    </button>
    <button nz-button nzType="primary" (click)="copySelectedRanges()" [disabled]="!hasSelectedRanges">
      Copy Selected
    </button>
    <button nz-button nzType="default" (click)="closeReceiversModal()">
      Done
    </button>
  </ng-template>
</nz-modal>